import gql from 'graphql-tag';
import { fileFragment } from '../../../gql/fragments/';
import { adFileFragment } from '../../../gql/fragments/AdFile';
export const adSetFragment = gql `
  fragment AdSet on AdSet {
    id
    name
    teamId
    adSetAllocations {
      id
      percentage
      events
      entityAdAllocationId
    }
    adFiles {
      ...AdFile
    }
  }
  ${adFileFragment}
  ${fileFragment}
`;
//# sourceMappingURL=adSetFragment.js.map